var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5348,
    height: 1284,
    viewBox: "0 0 5348 1284",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M939.525 1001C910.925 1001 887.091 994.5 868.025 981.5C849.825 968.5 840.725 954.2 840.725 938.6V443.3C840.725 425.1 849.825 410.367 868.025 399.1C887.091 387.833 910.925 382.2 939.525 382.2C964.658 382.2 985.891 387.833 1003.22 399.1C1020.56 410.367 1029.22 425.1 1029.22 443.3V491.4C1037.89 472.333 1050.02 454.133 1065.62 436.8C1082.09 418.6 1100.29 403.867 1120.22 392.6C1141.02 380.467 1162.26 374.4 1183.92 374.4H1221.62C1240.69 374.4 1257.16 383.067 1271.02 400.4C1285.76 417.733 1293.12 438.1 1293.12 461.5C1293.12 485.767 1285.76 506.567 1271.02 523.9C1257.16 541.233 1240.69 549.9 1221.62 549.9H1183.92C1160.52 549.9 1137.99 558.133 1116.32 574.6C1094.66 590.2 1076.89 612.3 1063.02 640.9C1049.16 669.5 1042.22 703.733 1042.22 743.6V938.6C1042.22 954.2 1032.26 968.5 1012.32 981.5C992.391 994.5 968.125 1001 939.525 1001Z",
    fill: "url(#paint0_linear_505_323)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1647.69 1014C1583.56 1014 1526.79 1002.73 1477.39 980.2C1427.99 956.8 1388.99 924.3 1360.39 882.7C1332.66 841.1 1318.79 793 1318.79 738.4V643.5C1318.79 594.967 1332.22 550.333 1359.09 509.6C1385.96 468.867 1421.92 436.367 1466.99 412.1C1512.06 386.967 1562.32 374.4 1617.79 374.4C1668.06 374.4 1713.99 384.8 1755.59 405.6C1798.06 426.4 1832.29 455.433 1858.29 492.7C1884.29 529.1 1897.29 572 1897.29 621.4C1897.29 660.4 1890.79 688.567 1877.79 705.9C1865.66 722.367 1849.62 732.767 1829.69 737.1C1810.62 740.567 1791.12 742.3 1771.19 742.3H1520.29V750.1C1520.29 782.167 1532.42 808.167 1556.69 828.1C1580.96 847.167 1613.02 856.7 1652.89 856.7C1679.76 856.7 1702.72 852.8 1721.79 845C1740.86 836.333 1757.76 828.1 1772.49 820.3C1787.22 812.5 1801.52 808.6 1815.39 808.6C1830.99 808.6 1844.42 813.8 1855.69 824.2C1866.96 834.6 1875.19 846.733 1880.39 860.6C1886.46 874.467 1889.49 886.6 1889.49 897C1889.49 913.467 1879.52 930.8 1859.59 949C1839.66 967.2 1811.49 982.8 1775.09 995.8C1739.56 1007.93 1697.09 1014 1647.69 1014ZM1520.29 629.2H1681.49C1691.02 629.2 1697.96 627.033 1702.29 622.7C1706.62 618.367 1708.79 610.133 1708.79 598C1708.79 580.667 1704.02 566.367 1694.49 555.1C1685.82 542.967 1674.12 534.3 1659.39 529.1C1645.52 523.033 1630.36 520 1613.89 520C1598.29 520 1583.12 523.033 1568.39 529.1C1554.52 534.3 1542.82 542.967 1533.29 555.1C1524.62 566.367 1520.29 580.667 1520.29 598V629.2Z",
    fill: "url(#paint1_linear_505_323)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2087.21 1283.1C2058.61 1283.1 2034.78 1276.6 2015.71 1263.6C1997.51 1250.6 1988.41 1236.3 1988.41 1220.7V443.3C1988.41 425.1 1997.51 410.367 2015.71 399.1C2034.78 387.833 2057.74 382.2 2084.61 382.2C2111.48 382.2 2133.58 387.833 2150.91 399.1C2168.24 410.367 2176.91 425.1 2176.91 443.3V473.2C2191.64 448.067 2214.18 425.533 2244.51 405.6C2275.71 384.8 2311.68 374.4 2352.41 374.4C2396.61 374.4 2436.04 386.967 2470.71 412.1C2506.24 436.367 2533.98 469.3 2553.91 510.9C2574.71 551.633 2585.11 597.133 2585.11 647.4V738.4C2585.11 786.067 2574.71 831.133 2553.91 873.6C2533.11 915.2 2505.38 949 2470.71 975C2436.91 1001 2399.64 1014 2358.91 1014C2320.78 1014 2286.11 1003.6 2254.91 982.8C2223.71 961.133 2202.04 936.867 2189.91 910V1220.7C2189.91 1236.3 2179.94 1250.6 2160.01 1263.6C2140.08 1276.6 2115.81 1283.1 2087.21 1283.1ZM2287.41 838.5C2304.74 838.5 2320.34 833.733 2334.21 824.2C2348.94 814.667 2360.64 802.1 2369.31 786.5C2378.84 770.9 2383.61 754.867 2383.61 738.4V647.4C2383.61 630.933 2379.28 615.333 2370.61 600.6C2361.94 585.867 2349.81 573.733 2334.21 564.2C2319.48 554.667 2303.01 549.9 2284.81 549.9C2269.21 549.9 2254.04 553.8 2239.31 561.6C2225.44 569.4 2213.74 580.667 2204.21 595.4C2194.68 609.267 2189.91 626.6 2189.91 647.4V755.3C2189.91 762.233 2193.81 772.633 2201.61 786.5C2210.28 799.5 2221.98 811.633 2236.71 822.9C2251.44 833.3 2268.34 838.5 2287.41 838.5Z",
    fill: "url(#paint2_linear_505_323)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3999.9 262.6C3970.43 262.6 3945.3 253.067 3924.5 234C3903.7 214.933 3893.3 193.267 3893.3 169C3893.3 143.867 3903.7 122.2 3924.5 104C3945.3 85.8 3970.43 76.7 3999.9 76.7C4029.37 76.7 4054.07 85.8 4074 104C4094.8 122.2 4105.2 143.867 4105.2 169C4105.2 193.267 4094.8 214.933 4074 234C4054.07 253.067 4029.37 262.6 3999.9 262.6ZM3999.9 1001C3970.43 1001 3946.17 994.5 3927.1 981.5C3908.9 968.5 3899.8 954.2 3899.8 938.6V443.3C3899.8 425.1 3908.9 410.367 3927.1 399.1C3946.17 387.833 3970.43 382.2 3999.9 382.2C4027.63 382.2 4051.47 387.833 4071.4 399.1C4091.33 410.367 4101.3 425.1 4101.3 443.3V938.6C4101.3 954.2 4091.33 968.5 4071.4 981.5C4051.47 994.5 4027.63 1001 3999.9 1001Z",
    fill: "url(#paint3_linear_505_323)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4248.38 1001C4224.12 1001 4206.78 993.633 4196.38 978.9C4186.85 963.3 4182.08 947.267 4182.08 930.8C4182.08 914.333 4185.55 899.167 4192.48 885.3C4200.28 871.433 4208.51 858.867 4217.18 847.6L4447.28 544.7H4248.38C4232.78 544.7 4219.35 536.9 4208.08 521.3C4196.81 504.833 4191.18 485.333 4191.18 462.8C4191.18 441.133 4196.38 422.5 4206.78 406.9C4217.18 390.433 4231.05 382.2 4248.38 382.2H4637.08C4653.55 382.2 4667.85 387.833 4679.98 399.1C4692.98 409.5 4699.48 425.967 4699.48 448.5C4699.48 477.967 4688.65 507 4666.98 535.6L4435.58 838.5H4665.68C4681.28 838.5 4694.71 846.733 4705.98 863.2C4717.25 878.8 4722.88 897.867 4722.88 920.4C4722.88 942.067 4717.68 961.133 4707.28 977.6C4696.88 993.2 4683.01 1001 4665.68 1001H4248.38Z",
    fill: "url(#paint4_linear_505_323)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5097.78 1014C5033.65 1014 4976.88 1002.73 4927.48 980.2C4878.08 956.8 4839.08 924.3 4810.48 882.7C4782.75 841.1 4768.88 793 4768.88 738.4V643.5C4768.88 594.967 4782.31 550.333 4809.18 509.6C4836.05 468.867 4872.01 436.367 4917.08 412.1C4962.15 386.967 5012.41 374.4 5067.88 374.4C5118.15 374.4 5164.08 384.8 5205.68 405.6C5248.15 426.4 5282.38 455.433 5308.38 492.7C5334.38 529.1 5347.38 572 5347.38 621.4C5347.38 660.4 5340.88 688.567 5327.88 705.9C5315.75 722.367 5299.71 732.767 5279.78 737.1C5260.71 740.567 5241.21 742.3 5221.28 742.3H4970.38V750.1C4970.38 782.167 4982.51 808.167 5006.78 828.1C5031.05 847.167 5063.11 856.7 5102.98 856.7C5129.85 856.7 5152.81 852.8 5171.88 845C5190.95 836.333 5207.85 828.1 5222.58 820.3C5237.31 812.5 5251.61 808.6 5265.48 808.6C5281.08 808.6 5294.51 813.8 5305.78 824.2C5317.05 834.6 5325.28 846.733 5330.48 860.6C5336.55 874.467 5339.58 886.6 5339.58 897C5339.58 913.467 5329.61 930.8 5309.68 949C5289.75 967.2 5261.58 982.8 5225.18 995.8C5189.65 1007.93 5147.18 1014 5097.78 1014ZM4970.38 629.2H5131.58C5141.11 629.2 5148.05 627.033 5152.38 622.7C5156.71 618.367 5158.88 610.133 5158.88 598C5158.88 580.667 5154.11 566.367 5144.58 555.1C5135.91 542.967 5124.21 534.3 5109.48 529.1C5095.61 523.033 5080.45 520 5063.98 520C5048.38 520 5033.21 523.033 5018.48 529.1C5004.61 534.3 4992.91 542.967 4983.38 555.1C4974.71 566.367 4970.38 580.667 4970.38 598V629.2Z",
    fill: "url(#paint5_linear_505_323)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M456.088 0C664.797 0 782 156.7 782 349.999C782 556.128 641.728 706.933 457.689 706.933C368.78 708.167 301.757 689.955 251.969 657.858L305.027 566.111C305.027 566.111 318.339 544.583 329.962 533.572C347.388 517.064 379.932 506.275 397.423 501.388C401.325 500.566 405.263 499.559 409.226 498.376C409.253 498.37 409.267 498.366 409.267 498.366L409.264 498.364C451.654 485.697 496.796 452.924 528.453 411.19C578.934 350.99 620.61 203.039 568.715 166.808C525.558 136.677 399.55 184.816 332.966 271.626C295.876 315.508 282.46 373.978 290.396 421.027L290.386 421.02C290.386 421.02 290.395 421.054 290.411 421.115C291.29 426.306 292.417 431.366 293.785 436.258C295.784 447.03 297.61 461.441 295.876 472.381C292.363 494.551 270.802 524.104 270.788 524.123L210.188 623.856C144.975 557.373 122.855 457.725 122.855 349.999C122.855 156.7 272.048 0 456.088 0Z",
    fill: "url(#paint6_linear_505_323)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M295.716 967.471C295.716 985.988 280.694 1001 262.164 1001H53.4434L295.716 582.065V967.471Z",
    fill: "url(#paint7_linear_505_323)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.179 18.7459C199.367 18.7459 212.661 28.9418 216.589 43.6032L267.033 231.873C267.497 233.605 267.821 235.373 268.003 237.157L292.996 483.109C286.099 503.02 270.715 524.107 270.704 524.123L0.0625527 969.534C0.0211124 968.851 0 968.163 0 967.471V52.2751C0 33.7574 15.0218 18.7459 33.5521 18.7459H184.179Z",
    fill: "url(#paint8_linear_505_323)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3294.59 263.258C3324.75 263.257 3349.19 287.695 3349.19 317.841V716.848L3323.98 521.033C3323.65 518.407 3321.41 516.442 3318.76 516.442C3315.8 516.442 3313.42 518.892 3313.5 521.856L3324.9 915.734C3325.01 919.297 3323.26 922.66 3320.28 924.625C3317.41 926.521 3313.79 926.859 3310.61 925.526L3308.82 924.771C3303.99 922.741 3300.71 918.179 3300.32 912.958L3271.12 522.765C3270.85 519.199 3267.88 516.442 3264.3 516.442C3260.57 516.442 3257.53 519.431 3257.47 523.159L3250.9 910.699C3250.79 917.215 3246.76 923.022 3240.69 925.408C3237.01 926.858 3232.92 926.9 3229.21 925.526L3228.94 925.429C3222.47 923.035 3218.11 916.939 3217.95 910.044L3208.49 522.54C3208.41 519.148 3205.64 516.442 3202.24 516.442C3198.98 516.442 3196.26 518.956 3196.01 522.213L3165.85 914.355C3165.51 918.773 3162.9 922.698 3158.96 924.724L3158.71 924.855C3155.27 926.619 3151.21 926.653 3147.74 924.945C3143.45 922.826 3140.79 918.389 3140.95 913.603L3154.25 521.599C3154.34 518.78 3152.08 516.442 3149.26 516.442C3146.75 516.442 3144.63 518.302 3144.31 520.788L3084.84 978.936C3083.87 986.338 3084 993.757 3085.16 1000.98H2992.8C2956.74 1000.98 2930.59 966.656 2940.16 931.904L3113.24 303.355C3119.76 279.671 3141.3 263.261 3165.87 263.26L3294.59 263.258Z",
    fill: "url(#paint9_linear_505_323)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3299.72 263.285C3324.29 263.285 3345.84 279.696 3352.36 303.38L3525.43 931.929C3535 966.681 3508.85 1001 3472.8 1001H3382.98C3383.94 994.229 3384 987.295 3383.11 980.373L3323.98 521.033C3323.65 518.407 3321.41 516.442 3318.76 516.442C3315.8 516.442 3313.42 518.892 3313.5 521.856L3324.9 915.734C3325.01 919.297 3323.26 922.66 3320.28 924.625C3317.41 926.521 3313.79 926.859 3310.61 925.526L3308.82 924.771C3303.99 922.741 3300.71 918.179 3300.32 912.958L3271.12 522.765C3270.85 519.199 3267.88 516.442 3264.3 516.442C3260.57 516.442 3257.53 519.431 3257.47 523.159L3250.9 910.699C3250.79 917.215 3246.76 923.022 3240.69 925.408C3237.01 926.858 3232.92 926.9 3229.21 925.526L3228.94 925.429C3222.47 923.035 3218.11 916.939 3217.95 910.044L3208.49 522.54C3208.41 519.148 3205.64 516.442 3202.24 516.442C3198.98 516.442 3196.26 518.956 3196.01 522.213L3165.85 914.355C3165.51 918.773 3162.9 922.698 3158.96 924.724L3158.71 924.855C3155.27 926.619 3151.21 926.653 3147.74 924.945C3143.45 922.826 3140.79 918.389 3140.95 913.603L3154.25 521.599C3154.34 518.78 3152.08 516.442 3149.26 516.442C3146.75 516.442 3144.63 518.302 3144.31 520.788L3116.41 735.746V317.866C3116.41 287.72 3140.85 263.282 3171 263.283L3299.72 263.285Z",
    fill: "url(#paint10_linear_505_323)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3631.92 69.7313C3641.25 41.063 3672.05 25.3789 3700.72 34.7L3803.27 68.0364C3831.89 77.3404 3847.59 108.047 3838.35 136.687L3571.98 963.126C3564.71 985.679 3543.71 1000.97 3520.01 1000.97H3404.24C3396.8 1000.97 3389.8 999.511 3383.45 996.899C3383.92 991.442 3383.82 985.904 3383.11 980.373L3369.69 876.115L3631.92 69.7313Z",
    fill: "url(#paint11_linear_505_323)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2762.28 34.6895C2790.95 25.3685 2821.75 41.0525 2831.08 69.7208L3096.79 886.813L3084.84 978.934C3084.16 984.175 3084.02 989.423 3084.41 994.603C3076.84 998.638 3068.15 1000.96 3058.76 1000.96H2942.99C2919.29 1000.96 2898.29 985.669 2891.02 963.115L2624.65 136.677C2615.41 108.037 2631.11 77.3298 2659.73 68.0259L2762.28 34.6895Z",
    fill: "url(#paint12_linear_505_323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_505_323",
    x1: 5347,
    y1: 0.0000558521,
    x2: 0.242278,
    y2: 1284.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BBD78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261735,
    stopColor: "#61B878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446759,
    stopColor: "#3EA279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669458,
    stopColor: "#1A8B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08827E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.34249dfb1a27cf4a254d4324b97fd94c.svg";
export { ForwardRef as ReactComponent };